import dayjs from 'dayjs';

// A person's profile state comes from `disabledAt` (null = enabled), never `isActive`.
// `isActive` only says the type CAN hold a login (every Zezamii user has it 1), not that one exists.

// Enabled keeps the value 'active': it is the StatusBadge colour key and the People default tab route.
export const PERSON_STATUS = Object.freeze({ ENABLED: 'active', DISABLED: 'disabled' });

export const isPersonDisabled = (person) => !!person?.disabledAt;

// App Server 403 `errorCode`s for a signed-in person who may not act in this org (roleMiddleware).
export const ACCESS_REFUSAL = Object.freeze({ DISABLED: 'PERSON_DISABLED', OUTSIDE_VALIDITY: 'OUTSIDE_VALIDITY' });
export const isAccessRefusal = (errorCode) => Object.values(ACCESS_REFUSAL).includes(errorCode);

// The signed-in profile is locked out of this org: disabled, or refused by the server.
export const isProfileLocked = (person) => isPersonDisabled(person) || !!person?.accessRefusal;

export const getPersonStatus = (person) => (isPersonDisabled(person) ? PERSON_STATUS.DISABLED : PERSON_STATUS.ENABLED);

export const PERSON_STATUS_LABEL = Object.freeze({ active: 'Enabled', disabled: 'Disabled' });

// Invite state computed by GET /people from Kinde: invited (InvitedAt) and first sign-in to this org (AcceptedDate).
export const INVITE_STATUS = Object.freeze({ NONE: 'none', PENDING: 'pending', ACCEPTED: 'accepted' });

// Has a Kinde account for this org (server `hasLogin`). Firebase-only people read false — offer an invite.
export const hasLogin = (person) => person?.hasLogin === true;

// Invited but has not signed in to this org yet.
export const isInvitePending = (person) => person?.inviteStatus === INVITE_STATUS.PENDING;

const PERSON_DATE_FORMAT = 'D MMM YYYY · HH:mm';
const formatPersonDate = (iso) => (iso && dayjs(iso).isValid() ? dayjs(iso).format(PERSON_DATE_FORMAT) : null);

// Drawer dates in local time. `modified` is the server's audit-backed lastModifiedAt (permissions,
// credentials, teams…); the raw modifiedDate misses those, so it never stands in.
export const personDates = (person) => ({
	added: formatPersonDate(person?.createdDate),
	modified: formatPersonDate(person?.lastModifiedAt)
});
